/* eslint-disable prettier/prettier */
export default {
  dbh_dashboard_giudebox_title: 'Dashboard Introduction',
  dbh_dashboard_giudebox_desc: 'Master game operation data comprehensively and intelligently analyze game performance . Here is Dashboard Introduction.',
  dbh_dashboard_giudebox_block_title: 'Tutorial-Core Functionality Display',
  dbh_dashboard_giudebox_list1_title: 'View game operation overview data',
  dbh_dashboard_giudebox_list1_desc: 'Overview of core game operation metrics on one page',
  dbh_dashboard_giudebox_list2_title: 'Monitor global real-time data',
  dbh_dashboard_giudebox_list2_desc: 'Quickly identify real-time metric change in different countries',
  dbh_dashboard_giudebox_list3_title: 'View global multi-timezone data',
  dbh_dashboard_giudebox_list3_desc: 'Obtain local timezone data, compare data by country',
  dbh_dashboard_giudebox_list4_title: 'View customized game dashboard',
  dbh_dashboard_giudebox_list4_desc: 'View analysis data of game features such as gameplay and activities',
  dbh_dashboard_giudebox_list5_title: 'Dashboard Subscription and Push',
  dbh_dashboard_giudebox_list5_desc: 'Receive the latest information timely , and automatically push daily/weekly/monthly reports',
};
